/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Settlement_DescInputs */

const vi_order_settlement_desc = /** @type {(inputs: Order_Settlement_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chọn hình thức khách thanh toán khi nhận hàng.`)
};

/**

* @param {Order_Settlement_DescInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_settlement_desc = /** @type {((inputs?: Order_Settlement_DescInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Settlement_DescInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_settlement_desc(inputs)
});